import { useEffect, useState } from 'react';

/**
 * `true` a partir de 1200px - o mesmo limite do breakpoint `lg` que o layout
 * usava via MUI.
 *
 * Existe para o layout novo nao depender de `useResponsive`, que arrasta o tema do
 * MUI para decidir uma media query. O valor inicial e lido de forma sincrona para
 * a primeira pintura ja sair com a sidebar do lado certo: comecar em `false` e
 * corrigir no efeito fazia a sidebar aparecer como gaveta e "pular" para o lado.
 */
export default function useTelaGrande(consulta = '(min-width: 1200px)') {
  const [grande, setGrande] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(consulta).matches
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia(consulta);
    const aoMudar = (e: MediaQueryListEvent) => setGrande(e.matches);
    setGrande(mq.matches);
    mq.addEventListener('change', aoMudar);
    return () => mq.removeEventListener('change', aoMudar);
  }, [consulta]);

  return grande;
}
